enum iaqSensorDataType{
    GET_IAQ_SENSOR_DATA_START='GET_IAQ_SENSOR_DATA_START',
    GET_IAQ_SENSOR_DATA_SUCCESS = 'GET_IAQ_SENSOR_DATA_SUCCESS',
    GET_IAQ_SENSOR_DATA_ERROR = 'GET_IAQ_SENSOR_DATA_ERROR',
    RESET_IAQ_SENSOR_DATA = 'RESET_IAQ_SENSOR_DATA',
    GET_IAQ_SENSOR_DATA_BY_ID_START='GET_IAQ_SENSOR_DATA_BY_ID_START',
    GET_IAQ_SENSOR_DATA_BY_ID_SUCCESS='GET_IAQ_SENSOR_DATA_BY_ID_SUCCESS',
    GET_IAQ_SENSOR_DATA_BY_ID_ERROR='GET_IAQ_SENSOR_DATA_BY_ID_ERROR',
    RESET_GET_IAQ_SENSOR_DATA_BY_ID_STATE='RESET_GET_IAQ_SENSOR_DATA_BY_ID_STATE',
}

export default iaqSensorDataType;